import { createVendorApi } from '@trackly/shared';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getTicketsApiBaseUrl();

/**
 * Single Vendor API instance for the web client — endpoint definitions live in
 * @trackly/shared (createVendorApi); only the authenticated baseQuery is web-specific.
 */
export const vendorApi = createVendorApi(createAuthenticatedBaseQuery(apiBaseUrl, 'Vendor API'));
